<template>
<div :class="['fit-toast-wrap',{show : !isHidden}]" v-on:touchmove.prevent >
    <div class="dock flex-center">
        <div class="content">
            <div class="dock flex-center">
                <div>
                    <img class="icon" v-if="image" :src="image"></img>
                    <i class="icon" :class="iconClass" v-else ></i>
                    <div class="txt" v-html="toastTitle"></div>
                    <div class="loading"></div>
                </div>
            </div>
        </div>
    </div>
</div>

</template>
<script>
import '../../themes/default/toast.css';
import base from '../../mixins/base.js';
const fitToast = {
  name: 'fit-toast',
  mixins: [base],
  data() {
    return {
      title: '',
      icon: 'none',
      image: '',
      duration: 0,
      isHidden: true,
    };
  },
  computed: {
    iconClass() {
      return this.icon ? `icon-${this.icon}` : '';
    },
    toastTitle() {
      if (!this.iconSrc) {
        return this.title;
      }
      if (this.title && this.title.length > 7) {
        return this.title.substring(0, 7);
      }
      return this.title;
    },
  },
  methods: {
    show(args) {
      const options = args ? args : {};
      this.image = '';
      this.hide();
      this.$nextTick(function () {
        [
          'title',
          'icon',
          'image',
          'duration',
        ].forEach((prop) => {
          if (options.hasOwnProperty(prop) && typeof this[prop] === typeof options[prop]) {
            this[prop] = options[prop];
          }
        });
        this.isHidden = false;
        if (this.duration) {
          this.timer = window.setTimeout(() => {
            this.isHidden = true;
          }, this.duration);
        }
      });
    },
    hide() {
      if (this.timer) {
        window.clearTimeout(this.timer);
        this.timer = null;
        this.duration = 0;
      }
      this.isHidden = true;
    },
  },
};
export default fitToast;
</script>
